import { render } from "./RequestPage.vue?vue&type=template&id=61a7f56f"
import script from "./RequestPage.vue?vue&type=script&lang=js"
export * from "./RequestPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__